import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AlertDialogComponent, SetAdminDialogComponent } from '../dialogs';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { IdentityService } from '../../identity/services/identity.service';
import { Environment } from '../../../environments/environment';

const environment: Environment = new Environment();
@Component({
	selector: 'app-pilotpay-toolbar',
	styleUrls: ['../pilotpay.component.scss'],
	templateUrl: './toolbar.component.html'
})
export class ToolbarComponent {
	constructor(private router: Router, private dialog: MatDialog, private identityService: IdentityService) {}

	@Input() isAdmin: boolean;
	@Input() isConnected: boolean;
	@Input() displayName: string;
	@Input() payScaleId?: number;
	@Input() employeeId?: number;
	@Output() toggleSidebarCollapseChanged: EventEmitter<boolean> = new EventEmitter();

	public environment: string | null = environment.isProduction()
		? null
		: environment.currentEnvironment().toUpperCase();

	public todayDate: string = moment.utc().format('YYYY-MM-DDTHH:mm:ss');
	public dialogConfig: MatDialogConfig = new MatDialogConfig();
	public alertDialogRef: MatDialogRef<AlertDialogComponent>;
	public adminDialogRef: MatDialogRef<SetAdminDialogComponent>;

	public logout(): void {
		this.dialogConfig.disableClose = false;
		this.dialogConfig.autoFocus = true;
		this.dialogConfig.data = {
			modalType: 'logout'
		};
		if (this.dialog) {
			this.alertDialogRef = this.dialog.open(AlertDialogComponent, this.dialogConfig);
		}
		if (this.alertDialogRef) {
			this.alertDialogRef.afterClosed().subscribe((isTrue: boolean) => {
				this.alertDialogRef = null;
				if (isTrue) {
					this.identityService.clearTokens();
					window.location.href = `${new Environment().getConfiguration().frontendIdentityUrl}/apps`;
				}
			});
		}
	}

	public openSetAdminUsersDialog(): void {
		const dialogConfig: MatDialogConfig = new MatDialogConfig();

		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.data = {};

		if (this.dialog) {
			this.adminDialogRef = this.dialog.open(SetAdminDialogComponent, dialogConfig);
		}
	}
}
